import produce from 'immer';
export var getInitialState = function () { return ({
    usersSharedAppsLoading: false,
    usersSharedAppsError: false,
    createLoading: false,
    createError: false,
    deleteLoading: false,
    deleteError: false,
    usersSharedApps: [],
    usersSharedByApps: [],
    usersSharedByAppsLoading: null,
    usersSharedByAppsError: false,
}); };
function usersSharedAppsReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'LOAD_USERS_SHARED_APPS_REQUEST':
                state.usersSharedAppsLoading = true;
                state.usersSharedAppsError = false;
                break;
            case 'LOAD_USERS_SHARED_APPS_SUCCESS':
                state.usersSharedAppsLoading = false;
                state.usersSharedAppsError = false;
                state.usersSharedApps = action.usersSharedApps || [];
                break;
            case 'LOAD_USERS_SHARED_APPS_FAILURE':
                state.usersSharedAppsLoading = false;
                state.usersSharedAppsError = true;
                state.usersSharedApps = [];
                break;
            case 'CREATE_USERS_SHARED_APP_REQUEST':
                state.createLoading = true;
                state.createError = false;
                break;
            case 'CREATE_USERS_SHARED_APP_SUCCESS':
                state.createLoading = false;
                state.createError = false;
                break;
            case 'CREATE_USERS_SHARED_APP_FAILURE':
                state.createLoading = false;
                state.createError = true;
                break;
            case 'DELETE_USERS_SHARED_APP_REQUEST':
                state.deleteLoading = true;
                state.deleteError = false;
                break;
            case 'DELETE_USERS_SHARED_APP_SUCCESS':
                state.deleteLoading = false;
                state.deleteError = false;
                state.usersSharedApps = state.usersSharedApps.filter(function (sa) { return sa.id !== action.usersSharedAppId; });
                break;
            case 'DELETE_USERS_SHARED_APP_FAILURE':
                state.deleteLoading = false;
                state.deleteError = action.error;
                break;
            case 'LOAD_USERS_SHARED_BY_APPS_REQUEST':
                state.usersSharedByAppsLoading = true;
                state.usersSharedByAppsError = false;
                break;
            case 'LOAD_USERS_SHARED_BY_APPS_SUCCESS':
                state.usersSharedByAppsLoading = false;
                state.usersSharedByAppsError = false;
                state.usersSharedByApps = action.usersSharedByApps || [];
                break;
            case 'LOAD_USERS_SHARED_BY_APPS_FAILURE':
                state.usersSharedByAppsLoading = false;
                state.usersSharedByAppsError = true;
                state.usersSharedByApps = [];
                break;
            default:
                break;
        }
    });
}
export default usersSharedAppsReducer;
